<div class="container-fluid">
  <page-header-breadcrumb
    [pageTitleValue]="pageTitle"
    [pageLinkValue]="'/tests'"
    [currentPageValue]="editMode ? 'Edit Test' : 'Add Test'"
  ></page-header-breadcrumb>
  <div class="card mb-4">
    <div class="card-body">
      <form [formGroup]="addTestForm" (ngSubmit)="onAddTestSubmit()">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="offer-name">
                Test EN Name
              </label>
              <input
                class="form-control"
                id="offer-name"
                formControlName="enTestName"
                placeholder="Test Name"
                type="text"
                pattern="[A-Za-z\s]+"
                title="Only English letters and spaces are allowed"
              />
              <div
                *ngIf="
                  (isSubmited || addTestForm.controls.enTestName.dirty) &&
                  addTestForm.controls.enTestName.errors
                "
                class="input-errors"
              >
                <p *ngIf="addTestForm.controls.enTestName.errors.required">
                  This field is required!
                </p>
                <p *ngIf="addTestForm.controls.enTestName.errors.pattern">
                  Only English letters and spaces are allowed!
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="offer-name">
                Test AR Name
              </label>
              <input
                class="form-control"
                id="offer-name"
                formControlName="arTestName"
                placeholder="Test Arabic Name"
                type="text"
                pattern="[\u0600-\u06FF\s]+"
                title="Only Arabic characters and spaces are allowed"
              />
              <div
                *ngIf="
                  (isSubmited || addTestForm.controls.arTestName.dirty) &&
                  addTestForm.controls.arTestName.errors
                "
                class="input-errors"
              >
                <p *ngIf="addTestForm.controls.arTestName.errors.required">
                  This field is required!
                </p>
                <p *ngIf="addTestForm.controls.arTestName.errors.pattern">
                  Only Arabic characters and spaces are allowed!
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row align-items-center">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="offer-route">
                Choose the Test Type
              </label>
              <select
                formControlName="testType"
                class="form-control"
                id="offer-route"
              >
                <option
                  *ngFor="let testType of testTypes"
                  [value]="testType.id"
                >
                  {{ testType.name }}
                </option>
              </select>
              <div
                *ngIf="isSubmited && addTestForm.controls.testType.errors"
                class="input-errors"
              >
                <p *ngIf="addTestForm.controls.testType.errors.required">
                  This field is required!
                </p>
              </div>
            </div>
          </div>
          <div class="col d-flex align-items-center">
            <label class="mr-6 mb-0" for="covid-check">Covid-19 Test?</label>
            <label class="custom-toggle custom-toggle-default">
              <input
                checked="checked"
                type="checkbox"
                id="covid-check"
                formControlName="testCovidCheck"
              />
              <span
                class="custom-toggle-slider rounded-circle"
                data-label-off="No"
                data-label-on="Yes"
              >
              </span>
            </label>
          </div>
          <div class="col d-flex align-items-center">
            <label class="mr-6 mb-0" for="bundle-check">Bundle?</label>
            <label class="custom-toggle custom-toggle-default">
              <input
                checked="checked"
                type="checkbox"
                id="bundle-check"
                formControlName="testBundleCheck"
              />
              <span
                class="custom-toggle-slider rounded-circle"
                data-label-off="No"
                data-label-on="Yes"
              >
              </span>
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col btns-block">
            <button class="btn btn-primary" type="submit" [disabled]="addTestForm.invalid">
              {{ editMode ? "Edit" : "Save" }}
            </button>
            <button
              class="btn btn-outline-danger"
              type="button"
              [routerLink]="'/tests'"
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
